import {IStrapiEntity, StrapiUtils} from "services/strapi";
import {ListItemsTable, ListItemsTableProps} from "components/common";
import {RoutesResolver} from "routes";
import {IQuote, TableSettings} from "features/quotes";

interface Props extends Omit<ListItemsTableProps<
    IQuote & { id: number },
    void>,
    'settings' | 'data'> {

    data?: IStrapiEntity<IQuote>[]
}

export function QuotesListTable({data, ...rest}: Props){
    const routesResolver = new RoutesResolver()
    return (
        <ListItemsTable
            {...rest}
            data={StrapiUtils.flattenStrapiEntities(data)}
            settings={TableSettings({
                routesResolver,
            })}
        />
    )
}